import axiosPrivate from "./axiosPrivate";

const getReclutamiento = (periodo) => {
    return axiosPrivate.get("personal-reclutamiento", {
        params: { periodo }
    }).then(response => response.data);
};

const insertReclutamiento = (data) => {
    return axiosPrivate.post("personal-reclutamiento", data)
        .then(response => response.data);
};

const deleteReclutamiento = (data) => {
    return axiosPrivate.delete("personal-reclutamiento", { data })
        .then(response => response.data);
};

const aprobarJefe = (data) => {
    return axiosPrivate.post("personal-reclutamiento/aprobar-jefe", data)
        .then(response => response.data);
};

const aprobarTH = (data) => {
    return axiosPrivate.post("personal-reclutamiento/aprobar-th", data)
        .then(response => response.data);
};

const observar = (data) => {
    return axiosPrivate.post("personal-reclutamiento/observar", data)
        .then(response => response.data);
};

// ─── Candidatos (tabla hija - múltiples por solicitud) ─────────────────────
const getCandidatos = (reclutamientoId) => {
    return axiosPrivate.get("personal-reclutamiento/candidatos", {
        params: { reclutamiento_id: reclutamientoId }
    }).then(response => response.data);
};

const insertCandidato = (data) => {
    return axiosPrivate.post("personal-reclutamiento/candidatos", data)
        .then(response => response.data);
};

const updateCandidato = (data) => {
    return axiosPrivate.put("personal-reclutamiento/candidatos", data)
        .then(response => response.data);
};

const deleteCandidato = (data) => {
    return axiosPrivate.delete("personal-reclutamiento/candidatos", { data })
        .then(response => response.data);
};

export default {
    getReclutamiento,
    insertReclutamiento,
    deleteReclutamiento,
    aprobarJefe,
    aprobarTH,
    observar,
    getCandidatos,
    insertCandidato,
    updateCandidato,
    deleteCandidato,
};